<template>
  <div v-if="data" class="report-view">
    <InterlayerPage
      :disable-count="pageCount"
      :site="site.name"
      section="synthesis"
      :baseline="site.name"
      :filters="filters"
      class="page"
      :title="$t('sections.synthesis')"
      :transports="[transportMode]"
      :comment="comment"
      :study-collaborators-count="data.collaboratorsCount"
      :transport-collaborators-count="data.filteredCollaboratorsCount"
    />

    <AnalysisSection v-for="(enumeration, idx) in enumerable()" :key="idx" :page-count="pageCount + idx + 1" :filters="filters">
      <template #banner>
        <Banner :data="data" :name="name" :site="site" />
      </template>
      <template #header>
        <h2>{{ $t('sections.synthesis') }}</h2>
        <h5>
          {{ $t('report.synthesisResults') }}
          <span v-if="enumerable().length > 1">{{ idx + 1 }}/{{ enumerable().length }}</span>
        </h5>
        <span>{{ $t('collaboratorsIncludedInResults', data.filteredCollaboratorsCount, { count: data.filteredCollaboratorsCount }) }}</span>
      </template>
      <template #body>
        <TargetSynthesis :data="data" :range="enumeration" :export="false" :forcedTransport="data.transportMode.key" />
      </template>
    </AnalysisSection>

    <AnalysisSection v-if="transportMode.key === 'custom'" :page-count="pageCount + enumerable().length + 1" :filters="filters">
      <template #banner>
        <Banner :data="data" :name="name" :site="site" />
      </template>
      <template #header>
        <h2>{{ $t('sections.synthesis') }}</h2>
        <h5>{{ $t('report.synthesisCollaboratorOrigins') }}</h5>
      </template>
      <template #body>
        <CollaboratorOrigins :data="data" />
      </template>
    </AnalysisSection>
  </div>
</template>

<script>
import AnalysisMixin from '@/components/Export/Analysis/Mixin';
import TargetSynthesis from '@/components/Analysis/Synthesis/TargetSynthesis';
import CollaboratorOrigins from '@/components/Analysis/Synthesis/CollaboratorOrigins';

export default {
  components: {
    TargetSynthesis,
    CollaboratorOrigins,
  },

  mixins: [AnalysisMixin],
};
</script>
